<template>
  <div class="studentWish">
    <div class="boxs">
      <div class="voice-content container">
        <div class="content-title">
          学员心声
          <img src="@img/comment.png" alt @click="toShowShades" />
        </div>
        <div class="voice">
          <div
            class="voice-box"
            v-for="item in voiceList"
            :key="item.id"
            v-show="voiceList.length>0"
          >
            <div class="voice-corver">
              <img v-if="item.img_url != null" :src="item.img_url" alt />
              <img v-else-if="item.img_url == null" src="@img/user_default.png" alt />
            </div>
            <div class="voice-detail">
              <div class="title">
                <p>
                  <span class="span0">{{item.user_name}}</span>
                  <span class="span1">{{item.create_time | dateformat('YYYY-MM-DD')}}</span>
                </p>
              </div>
              <div class="content" @click="showContent(item.content)">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shades" v-show="showShades" @click="cancel"></div>
    <div class="reply" v-show="showShades">
      <p>学员留言</p>
      <a-textarea
        class="reply-box"
        maxlength="101"
        @input="changeInput()"
        onchange="this.value=this.value.substring(0, 100)"
        onkeydown="this.value=this.value.substring(0, 100)"
        onkeyup="this.value=this.value.substring(0, 100)"
        v-model="message"
        placeholder="请输入评论"
      />
      <a-button class="reply-btn" type="primary" block @click="commitReply">提交</a-button>
      <a-button class="reply-btn" block @click="cancel">取消</a-button>
    </div>
    <a-alert :message="errmsg" v-if="errshow" class="errshow" type="error" showIcon />
  </div>
</template>
<script>
import { getCookie, group_sign } from "../../utils/tool";
import { mapState } from "vuex";
export default {
  name: "StudentWish",
  data() {
    return {
      showShades: false,
      topId:Number(getCookie('top_category_id')),
      account_id:Number(getCookie('account_id')),
      student_id: Number(getCookie('studentId')),
      user_name: getCookie('userAcount'),
      avatar: getCookie('avatar'),
      voiceList: [],
      token: getCookie('token'),
      message: "",
      errmsg: "",
      errshow: false,
    };
  },
  computed: {
    ...mapState(["isLogin"])
  },
  methods: {
    showContent(item){
      alert(item)
    },
    // 获取学员心声列表
    getVoiceList() {
      let that = this;
      var param = group_sign({
        page: 1,
        page_size: 9999
      });
      this.$axios.post(this.$Api.apiGetStudentWishList, param).then(res => {
        if (res.data.errcode == 0) {
          that.voiceList = res.data.result.list;
        }
      });
    },
    toShowShades() {
      if (this.isLogin) {
        this.showShades = true;
      } else {
        this.$root.Bus.$emit("showLogin");
      }
    },
    changeInput() {
      if (this.message.length > 100) {
        alert("输入字数不能超过100");
      }
    },
    cancel() {
      this.message = "";
      this.showShades = false;
    },
    // 学员心声回复
    commitReply() {
      let that = this;
      var param = group_sign({
        student_id: that.student_id,
        user_name: that.user_name,
        content: that.message,
      });
      if (that.message && that.token) {
        this.$axios.post(this.$Api.apiSaveStuWishVoice, param).then(res => {
          if (res.data.errcode == 0) {
            that.$message.success("评论成功！")
            that.message = "";
            that.showShades = false;
          } else if (res.data.errcode == 403) {
            that.errshow = true;
            that.errmsg = res.data.errmsg;
            let timeError = setTimeout(() => {
              that.errmsg = "";
              that.errshow = false;
              clearTimeout(timeError);
            }, 2000);
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin");
              clearTimeout(timeErrors);
            }, 2000);
          }
        });
      }
    }
  },
  beforeMount() {
    this.getVoiceList();
  }
};
</script>
<style lang="less" scope>
@import url("../../assets/less/studentWish.less");
</style>